import { BaseTableEntities } from '@/types'

const paymentTables: BaseTableEntities = {
  subscriptionPayload: [
    {
      value: 'customer',
      text: '',
      formatter: (value) => value ? `${value.name} | ${value.cpfCnpj} | ${value.email}` : value
    },
    {
      value: 'moduleName',
      text: '',
      hidden: true
    },
    {
      value: 'partner',
      text: '',
      sortable: false,
      formatter: (value) => value ? `${value.name} | ${value.cpfCnpj} | ${value.email}` : value
    },
    {
      value: 'groupSerial',
      text: '',
      sortable: false
    },
    {
      value: 'invoiceAmount',
      text: '',
      sortable: false
    },
    {
      value: 'sellerId',
      text: '',
      sortable: false
    },
    {
      value: 'createdDate',
      text: '',
      auditing: true
    },
    {
      value: 'id',
      text: '',
      auditing: true
    }
  ],
  customerPayload: [
    {
      value: 'personType',
      text: '',
      hidden: true
    },
    {
      value: 'stateInscription',
      text: '',
      sortable: false
    },
    {
      value: 'groupSeries',
      text: '',
      sortable: false
    },
    {
      value: 'postalCode',
      text: '',
      auditing: true
    },
    {
      value: 'address',
      text: '',
      auditing: true
    },
    {
      value: 'addressNumber',
      text: '',
      auditing: true
    },
    {
      value: 'complement',
      text: '',
      auditing: true
    },
    {
      value: 'province',
      text: '',
      auditing: true
    },
    {
      value: 'city',
      text: '',
      sortable: false,
      auditing: true
    },
    {
      value: 'state',
      text: '',
      sortable: false,
      auditing: true
    },
    {
      value: 'country',
      text: '',
      sortable: false,
      auditing: true
    },
    {
      value: 'createdDate',
      text: '',
      auditing: true
    },
    {
      value: 'id',
      text: '',
      auditing: true
    }
  ],
  partnerPayload: [
    {
      value: 'personType',
      text: '',
      hidden: true
    },
    {
      value: 'postalCode',
      text: '',
      auditing: true
    },
    {
      value: 'address',
      text: '',
      auditing: true
    },
    {
      value: 'addressNumber',
      text: '',
      auditing: true
    },
    {
      value: 'complement',
      text: '',
      auditing: true
    },
    {
      value: 'province',
      text: '',
      auditing: true
    },
    {
      value: 'city',
      text: '',
      sortable: false,
      auditing: true
    },
    {
      value: 'state',
      text: '',
      sortable: false,
      auditing: true
    },
    {
      value: 'country',
      text: '',
      sortable: false,
      auditing: true
    },
    {
      value: 'id',
      text: '',
      auditing: true
    }
  ]
}

export default paymentTables